export type NestedNullable<T> = {
  [K in keyof T]: T[K] | null;
};

export enum EVisibility {
  ALTA = 'ALTA',
  MEDIA = 'MEDIA',
  BAJA = 'BAJA',
}

export enum StatusEnrichmentEnum {
  ERROR = 'error',
  PROCESSED = 'processed',
  PROCESSING = 'processing',
  REPROCESSING = 'reprocessing',
  REPROCESSED = 'reprocessed',
  NOT_PROCESSED = 'not_processed',
}
